import authAxios from 'utils/authAxios';

//PAYER LIST
export const getPayerList = (body) => {
  return authAxios.post(`api/v1/getListOfPayers`, body);
};
export const getPayerProcCountList = (body) => {
  return authAxios.post(`api/v1/getPayerProcCountList`, body);
};

// CATEGORY lIST
export const getCategoryList = (body) => {
  return authAxios.post(`api/v1/getDashboardCategories`, body);
};

/*DRG CPT OVERVIEW'S*/
export const getTopPrefEntityList = (body) => {
  return authAxios.post(`api/v1/getTopPrefEntityList`, body);
};

export const getOverviewCPTList = (body) => {
  return authAxios.post(`api/v1/getTopPrefCPTs`, body);
};

export const getOverviewDRGList = (body) => {
  return authAxios.post(`api/v1/getTopPrefDRGs`, body);
};

export const gettopProceduresL4 = (state) => {
  return authAxios.post(`api/v1/getTopPrefCPTsL4`, state);
};

export const gettopProceduresNonPrefL4 = (state) => {
  return authAxios.post(`api/v1/getTopNonPrefCPTsL4`, state);
};

/*PAYERS SCREENS*/
export const getHospitalList = (body) => {
  return authAxios.post(`api/v1/getHospitallist`, body);
};

export const getAncillaryList = (body) => {
  return authAxios.post(`api/v1/getAncillarylist`, body);
};

export const getNpiList = (body) => {
  return authAxios.post(`api/v1/getNPIlist`, body);
};

export const getBillingCodeTypeList = (body) => {
  return authAxios.post(`api/v1/getBillingCodeTypeList`, body);
};

export const getProceduresCatList = (body) => {
  return authAxios.post(`api/v1/getCategoryList`, body);
};

export const getLevel1DescList = (body) => {
  return authAxios.post(`api/v1/getDescriptionList`, body);
};

export const getProcedureNameList = (body) => {
  return authAxios.post(`api/v1/getProcedureList`, body);
};

export const getModifierList = (body) => {
  return authAxios.post(`api/v1/getmodifierList`, body);
};

export const getPayerPriceCompList = (body) => {
  return authAxios.post(`api/v1/getPayerPriceComparison`, body);
};
//Filter DRG List

export const getFilteredDRGHospitalList = (body) => {
  return authAxios.post(`api/v1/getFilteredDRGHospitalList`, body);
};

export const getFilteredDRGAncillaryList = (body) => {
  return authAxios.post(`api/v1/getFilteredDRGAncillaryList`, body);
};

export const getFilteredDRGPayerList = (body) => {
  return authAxios.post(`api/v1/getFilteredDRGPayerList`, body);
};
export const getFilteredDRGBillingCodeType = (body) => {
  return authAxios.post(
    `api/v1/getFilteredDRGBillingCodeType
`,
    body
  );
};

export const getFilteredDRGBillingCodes = (body) => {
  return authAxios.post(
    `api/v1/getFilteredDRGBillingCodes
`,
    body
  );
};

export const getFilteredDRGListData = (body) => {
  return authAxios.post(
    `api/v1/getFilteredDRGListData
`,
    body
  );
};

//DRG cost breakdown

export const getDRGcostallentity = (body) => {
  return authAxios.post(`api/v1/drgcostbreakdown/getallreportingentityname`, body);
};
export const getDRGProviderName = (body) => {
  return authAxios.post(`api/v1/drgcostbreakdown/getProviderName`, body);
};

export const getDRGCodeCategory = (body) => {
  return authAxios.post(`api/v1/drgcostbreakdown/getcodecategory`, body);
};

export const getDRGReportingEntityName = (body) => {
  return authAxios.post(`api/v1/drgcostbreakdown/getreportingentityname`, body);
};

export const getDRGBreakdown = (body) => {
  return authAxios.post(`api/v1/drgcostbreakdown/getbreakdown`, body);
};

export const getStateMapDataList = (body) => {
  return authAxios.post(`api/v1/getStateMapData`, body);
};
export const getRegionalMapDataList = (body) => {
  return authAxios.post(`api/v1/getReginalMapData`, body);
};

/*HISTORICAL REQUESTS*/
export const getHistoricalRequests = () => {
  return authAxios.post(`api/v1/getAllOnDemandRequests`, {});
};

export const getSignedUrl = (body) => {
  return authAxios.post(`api/v1/getSignedUrl`, body);
};

export const placeReRequest = (body) => {
  return authAxios.post(`api/v1/placeReRequest`, body);
};

/*FACILITY SCORECARD*/
export const getFacilityScoreCardScores = () => {
  return authAxios.post(`api/v1/facilityScorecard-scores`);
};

export const getFacilityScoreCardNPIs = () => {
  return authAxios.post(`api/v1/facilityScorecard-npis`);
};

export const getProviderExtractFilters = (body = []) => {
  return authAxios.post(`api/v1/getProviderExtractFilters`, body);
};

export const getProviderExtractResults = (body) => {
  return authAxios.post(`api/v1/getProviderExtractResults`, body);
};

export const getProviderExtractResultsCharts = (body) => {
  return authAxios.post(`api/v1/getProviderExtractResultsCharts`, body);
};
